module.exports = "../dist/frontend/icons/logo/green.svg?f6e28d8f861e3ee544a0a6b7cfd6cf13";